import { JsonPipe } from '@angular/common';
import { Component, Input, Signal, WritableSignal, inject } from '@angular/core';
import { MatButtonModule } from '@angular/material/button';
import { MatExpansionModule } from '@angular/material/expansion';
import { MatIconModule } from '@angular/material/icon';
import { ActivatedRoute, Router } from '@angular/router';
import { AratChartComponent } from '../../../components/arat-chart/arat-chart.component';
import { BarChartComponent } from '../../../components/bar-chart/bar-chart.component';
import { ChartBaseComponent } from '../../../components/chart-base/chart-base.component';
import { DoubleBarChartComponent } from '../../../components/double-bar-chart/double-bar-chart.component';
import { ExampleChartComponent } from '../../../components/example-chart/example-chart.component';
import { LineChartNhptComponent } from '../../../components/line-chart-nhpt/line-chart-nhpt.component';
import { LineChartPercentComponent } from '../../../components/line-chart-percent/line-chart-percent.component';
import { LineChartSingleComponent } from '../../../components/line-chart-single/line-chart-single.component';
import { LineChartComponent } from '../../../components/line-chart/line-chart.component';
import { SingleBarChartComponent } from '../../../components/single-bar-chart/single-bar-chart.component';
import { AssessmentsService } from '../../../services/assessments.service';
import { Assessment, AssessmentChartDataSets } from '../../../services/model';
import { PatientsService } from '../../../services/patients.service';
import { AssessmentTableComponent } from './assessment-table/assessment-table.component';
import { LineChartMultiComponent } from '../../../components/line-chart-multi/line-chart-multi.component';
import { LineChartNhptBarsComponent } from '../../../components/line-chart-nhpt-bars/line-chart-nhpt-bars.component';
import { fgaInfo } from '../../../../../domain/src/assessments/fga';
import { bbsInfo } from '../../../../../domain/src/assessments/bbs';
import { bbtInfo } from '../../../../../domain/src/assessments/bbt';
import { nhptInfo } from '../../../../../domain/src/assessments/nhpt';
import { aratInfo } from '../../../../../domain/src/assessments/arat';
import { tugInfo } from '../../../../../domain/src/assessments/tug';

@Component({
  selector: 'app-graph',
  standalone: true,
  imports: [
    MatButtonModule,
    MatIconModule,
    MatExpansionModule,
    ChartBaseComponent,
    LineChartComponent,
    LineChartPercentComponent,
    BarChartComponent,
    AratChartComponent,
    SingleBarChartComponent,
    DoubleBarChartComponent,
    AssessmentTableComponent,
    JsonPipe,
    ExampleChartComponent,
    LineChartSingleComponent,
    LineChartNhptComponent,
    LineChartNhptBarsComponent,
    LineChartMultiComponent,
  ],
  templateUrl: './graph.component.html',
  styleUrl: './graph.component.scss',
})
export class GraphComponent {
  @Input() patientId?: string;

  public aratInfo = aratInfo;
  public bbsInfo = bbsInfo;
  public bbtInfo = bbtInfo;
  public fgaInfo = fgaInfo;
  public nhptInfo = nhptInfo;
  public tugInfo = tugInfo;

  private assessmentsService: AssessmentsService = inject(AssessmentsService);
  public patientsService: PatientsService = inject(PatientsService);
  private router: Router = inject(Router);
  private route: ActivatedRoute = inject(ActivatedRoute);

  assessmentList: WritableSignal<Assessment[]> = this.assessmentsService.assessmentList;

  assessmentChartDataSets: Signal<AssessmentChartDataSets | undefined> =
    this.assessmentsService.assessmentChartDataSets.asReadonly();

  constructor() {
    console.log('constructor GraphComponent');
  }

  newAssessment() {
    this.router.navigate(['../../assessments/new'], { relativeTo: this.route });
  }

  newAssessmentOfType(type: string) {
    this.router.navigate(['../../assessments/' + type], { relativeTo: this.route });
  }

  navigateToAssessment(assessment: Assessment) {
    console.log('ass', assessment);
    if (assessment) {
      this.router.navigate(['../../assessments/' + assessment.type.toLowerCase() + '/' + assessment._documentId], {
        relativeTo: this.route,
      });
    }
  }

  // von  reports/assessments
  // nach assessments/arat
  onArat() {
    this.router.navigate(['../../assessments/arat'], { relativeTo: this.route });
  }

  getHeight() {
    return document.body.scrollHeight;
  }
}
